/* TODO: t() */
import React, { createContext, useCallback, useContext, useRef } from 'react';
import { View, StyleSheet } from 'react-native';

import createViewComponent from '../../support/rn-web/createViewComponent';

type SubmitForm = ((event?: unknown) => void) | undefined;

export const FormContext = createContext<SubmitForm>(undefined);

const FormView = createViewComponent({
  tagName: 'form',
  additionalProps: {
    onSubmit: true,
    autoComplete: true,
  },
});

type Props = React.ComponentProps<typeof FormView>;

export default function Form(props: Props) {
  let { children, onSubmit, ...otherProps } = props;
  let buttonRef = useRef<HTMLButtonElement>(null);
  let doSubmit = useCallback(() => {
    buttonRef.current?.click();
  }, []);
  return (
    <FormContext.Provider value={doSubmit}>
      <FormView
        onSubmit={(event) => {
          event.preventDefault();
          onSubmit?.(event);
        }}
        {...otherProps}
      >
        {children}
        <View style={styles.hiddenView}>
          <button ref={buttonRef} type="submit" tabIndex={-1} />
        </View>
      </FormView>
    </FormContext.Provider>
  );
}

export function useSubmitForm() {
  return useContext(FormContext);
}

let styles = StyleSheet.create({
  hiddenView: {
    width: 0,
    height: 0,
    overflow: 'hidden',
    position: 'absolute',
  },
});
